import request from "../request";

/**
 * 上传文件
 * @param params 上传文件参数
 * @returns 上传文件结果
 */
export const uploadFile = async (params: any) => {
  return request.post("/knowledge/upload", {
    data: params,
  });
};
/**
 * 分类列表
 * @param params 分类列表参数
 * @returns 分类列表结果
 */
export const getCategoryList = async (params: any) => {
  return request.get("/website/cateList", {
    params,
  });
};
/**
 * 分类聚合列表
 * @param params 分类列表参数
 * @returns 分类列表结果
 */
export const getGroupByCateList = async (params: any) => {
  return request.get("/website/groupByCateList", {
    params,
  });
};
/**
 * 标识提醒列表
 * @param params 标识提醒列表参数
 * @returns 标识提醒列表结果
 */
export const getBiddingNoticeList = async (params: any) => {
  return request.get("/biddingNotice/list", {
    params,
  });
};
/**
 * 标识提醒列表
 * @param params 标识提醒列表参数
 * @returns 标识提醒列表结果
 */
export const getUserNoticeList = async (params: any) => {
  return request.get("/userNotice/list", {
    params,
  });
};
/**
 * 设置单个通知为已读
 * @param params 标识提醒列表参数
 * @returns 标识提醒列表结果
 */
export const setNoticeRead = async (id: any) => {
  return request.post(`/userNotice/${id}/read`, {

  });
};
/**
 * 设置单个通知为已读
 * @param params 标识提醒列表参数
 * @returns 标识提醒列表结果
 */
export const setAllRead = async () => {
  return request.post(`/userNotice/readAll`, {

  });
};





